<template>
  <div class="page" v-if="Info" >
    <div class="view" style="padding:0px 30px;box-sizing: border-box;width: 100%;height: 700px;overflow: auto;">
      <div class="ViewBox" >
        <div class="comView">
          <div class="comItem">
            <div class="comItemName">质检时间：:</div>
            {{$public.FTime(Info.checkTime)}}
          </div>
          <div class="comItem">
            <div class="comItemName">质检人：:</div>
            {{ Info.checkUserName
            }}
          </div>
          <div class="comItem">
            <div class="comItemName">传染病:</div>
            <el-input
              :value="Info.chuanRanBing_check_status == 0 ? '阴性' : Info.chuanRanBing_check_status == 1 ? '弱阳' : '强阳'"
              disabled style="width: 100px;"></el-input>
          </div>
          <div class="comItem">
            <div class="comItemName">咬合有无异常:</div>
            <el-input :value="Info.yaoHe_check_status == 0 ? '无' : '有'" disabled style="width: 100px;"></el-input>
            <div v-if="Info.yaoHe_img" class="comItemImg">
              <div class="comItemImg_p" v-for="item in Info.yaoHe_img" :key="item"> <el-image
                  style="width: 100px; height: 100px" :src="item" :preview-src-list="Info.yaoHe_img">
                </el-image></div>
            </div>
          </div>
          <div class="comItem">
            <div class="comItemName">眼口鼻有无异常:</div>
            <el-input :value="Info.yanKouBi_check_status == 0 ? '无' : '有'" disabled style="width: 100px;"></el-input>
            <div v-if="Info.yanKouBi_img" class="comItemImg"> <div class="comItemImg_p" v-for="item in Info.yanKouBi_img" :key="item"> <el-image
                  style="width: 100px; height: 100px" :src="item" :preview-src-list="Info.yanKouBi_img">
                </el-image></div></div>
          </div>
          <div class="comItem">
            <div class="comItemName">四肢有无残缺:</div>
            <el-input :value="Info.siZhi_check_status == 0 ? '无' : '有'" disabled style="width: 100px;"></el-input>
            <div v-if="Info.siZhi_img" class="comItemImg"> <div class="comItemImg_p" v-for="item in Info.siZhi_img" :key="item"> <el-image
                  style="width: 100px; height: 100px" :src="item" :preview-src-list="Info.siZhi_img">
                </el-image></div></div>
          </div>
          <div class="comItem">
            <div class="comItemName">尾巴有无折尾:</div>
            <el-input :value="Info.weiBa_check_status == 0 ? '无' : '有'" disabled style="width: 100px;"></el-input>
            <div v-if="Info.weiBa_img" class="comItemImg"> <div class="comItemImg_p" v-for="item in Info.weiBa_img" :key="item"> <el-image
                  style="width: 100px; height: 100px" :src="item" :preview-src-list="Info.weiBa_img">
                </el-image></div></div>
          </div>
          <div class="comItem">
            <div class="comItemName">有无大面积皮肤病:</div>
            <el-input :value="Info.daMianJiPiFuBing_check_status == 0 ? '无' : '有'" disabled
              style="width: 100px;"></el-input>
            <div v-if="Info.daMianJiPiFuBing_img" class="comItemImg"> <div class="comItemImg_p" v-for="item in Info.daMianJiPiFuBing_img" :key="item"> <el-image
                  style="width: 100px; height: 100px" :src="item" :preview-src-list="Info.daMianJiPiFuBing_img">
                </el-image></div></div>
          </div>
          <div class="comItem">
            <div class="comItemName">有无寄生虫:</div>
            <el-input :value="Info.jiShengChong_check_status == 0 ? '无' : '有'" disabled
              style="width: 100px;"></el-input>
            <div v-if="Info.jiShengChong_img" class="comItemImg"> <div class="comItemImg_p" v-for="item in Info.jiShengChong_img" :key="item"> <el-image
                  style="width: 100px; height: 100px" :src="item" :preview-src-list="Info.jiShengChong_img">
                </el-image></div></div>
          </div>
          <div class="comItem">
            <div class="comItemName">有无隐睾:</div>
            <el-input :value="Info.yinGao_check_status == 0 ? '无' : '有'" disabled style="width: 100px;"></el-input>
            <div v-if="Info.yinGao_img" class="comItemImg"> <div class="comItemImg_p" v-for="item in Info.yinGao_img" :key="item"> <el-image
                  style="width: 100px; height: 100px" :src="item" :preview-src-list="Info.yinGao_img">
                </el-image></div></div>
          </div>
          <div class="comItem">
            <div class="comItemName">有无脐疝:</div>
            <el-input :value="Info.qiShan_check_status == 0 ? '无' : '有'" disabled style="width: 100px;"></el-input>
            <div v-if="Info.qiShan_img" class="comItemImg"> <div class="comItemImg_p" v-for="item in Info.qiShan_img" :key="item"> <el-image
                  style="width: 100px; height: 100px" :src="item" :preview-src-list="Info.qiShan_img">
                </el-image></div></div>
          </div>
          <div class="comItem">
            <div class="comItemName">听力是否异常:</div>
            <el-input :value="Info.tingLi_check_status == 0 ? '无' : '有'" disabled style="width: 100px;"></el-input>
            <div v-if="Info.tingLi_img" class="comItemImg"> <div class="comItemImg_p" v-for="item in Info.tingLi_img" :key="item"> <el-image
                  style="width: 100px; height: 100px" :src="item" :preview-src-list="Info.tingLi_img">
                </el-image></div></div>
          </div>
          <div class="comItem">
            <div class="comItemName">腹部有无明显肿胀:</div>
            <el-input :value="Info.fuBuZhongZhang_check_status == 0 ? '无' : '有'" disabled
              style="width: 100px;"></el-input>
            <div v-if="Info.fuBuZhongZhang_img" class="comItemImg"> <div class="comItemImg_p" v-for="item in Info.fuBuZhongZhang_img" :key="item"> <el-image
                  style="width: 100px; height: 100px" :src="item" :preview-src-list="Info.fuBuZhongZhang_img">
                </el-image></div></div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nickName: '123', //商品名称
      Info: {}
    }
  },
  props: {
    checkInfo: {
      default: "",
    }
  },
  mounted() {
    this.Info = this.checkInfo
    console.log(this.checkInfo, 'checkInfo');
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  color: $fontColor;

  .view {
    background: #fff;
    height: 100%;

    border-radius: 20px;
    display: flex;
    flex-direction: column;

    .viewT {
      box-sizing: border-box;
      height: 68px;
      display: flex;
      align-items: center;
      border-bottom: solid 1px #F2F2F2;
      padding: 0 20px;
      justify-content: space-between;
    }

    .ViewBox {
      flex: 1;
      overflow-y: scroll;

      .viewnickName {
        border-top: 1px solid gray;
        padding-top: 20px;
        span {
          margin: 20px 20px;
        }
      }

      .comView {
        align-items: center;
        margin: 20px;
        font-size: 14px;

        .comItem {
          display: flex;
          align-items: center;
          // height: 40px;
          margin: 20px 0;

          .comItemImg {
            display: flex;

            .comItemImg_p {
              width: 80px;
              height: 80px;
              object-fit: cover;
              margin: 10px 20px;
            }

            img {
              width: 100%;
              height: 100%;

            }
          }

          .comItemName {
            width: 150px;
            text-align: right;
            margin-right: 8px;

            span {
              color: #FF3939;
            }
          }
        }

        .comTxt {
          color: #666;
          margin-left: 12px;

          span {
            color: #F77E04;
            cursor: pointer;
          }
        }
      }

    }

    .viewB {
      height: 68px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      box-sizing: border-box;
      border-top: solid 1px #F2F2F2;
    }

    .viewC::-webkit-scrollbar {
      display: none;
    }
  }

  .upload-cropper-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cropper-upload-box {
    display: flex;

    .el-upload {
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 90%;
        max-height: 90%;
      }
    }
  }
  
}
</style>
